import React from 'react';
import { SystemSettings } from '../components';

export default () => {
	return <SystemSettings.Home />;
};
